export default __webpack_public_path__ + "static/media/web3-main-bg.1551d195.png";